import React from 'react';
import { PrimaryButton } from '../../../components/Buttons';
import { sanitizeHTML } from '../../../utils/sanitizeHTML';

type NotStartedViewProps = {
  assessmentName: string;
  questionCount: number;
  introduction: string;
  isStarting: boolean;
  onStart: () => void;
};

export function NotStartedView({
  assessmentName,
  questionCount,
  introduction,
  isStarting,
  onStart,
}: NotStartedViewProps) {
  return (
    <>
      <p>Let&rsquo;s get started taking the {assessmentName}.</p>
      <p className="text-color-medium">
        {questionCount} question{questionCount > 1 ? 's' : ''}
      </p>
      <div
        className="text-color-medium"
        dangerouslySetInnerHTML={{ __html: sanitizeHTML(introduction, { ADD_ATTR: ['target'] }) }}
      ></div>
      <p>Use the &ldquo;Start&rdquo; button to take this assessment.</p>
      <p>
        <PrimaryButton
          data-qa-hook="assessmentStartButton"
          onClick={onStart}
          disabled={isStarting}
          operating={isStarting}
        >
          Start
        </PrimaryButton>
      </p>
    </>
  );
}

type InProgressViewProps = {
  assessmentName: string;
  questionCount: number;
  introduction: string;
  progress: number;
  onResume: () => void;
};

export function InProgressView({
  assessmentName,
  questionCount,
  introduction,
  progress,
  onResume,
}: InProgressViewProps) {
  return (
    <>
      <p>It looks like you have already started taking the {assessmentName}.</p>
      <p className="text-color-medium">
        You have answered {progress} of {questionCount} question
        {questionCount > 1 ? 's' : ''}
      </p>
      <div
        className="text-color-medium"
        dangerouslySetInnerHTML={{ __html: sanitizeHTML(introduction, { ADD_ATTR: ['target'] }) }}
      ></div>
      <p>Use the &ldquo;Resume&rdquo; button to continue taking this assessment.</p>
      <p>
        <PrimaryButton onClick={onResume}>Resume</PrimaryButton>
      </p>
    </>
  );
}

type CompletedViewProps = {
  assessmentName: string;
  questionCount: number;
  conclusion: string;
};

export function CompletedView({ assessmentName, questionCount, conclusion }: CompletedViewProps) {
  return (
    <>
      <p>You have finished the {assessmentName}.</p>
      <p className="text-color-medium">
        {questionCount} of {questionCount} questions answered
      </p>
      <div
        className="text-color-medium"
        dangerouslySetInnerHTML={{ __html: sanitizeHTML(conclusion, { ADD_ATTR: ['target'] }) }}
      ></div>
    </>
  );
}
